// --------------------------------------------------------
// this file replaces text in the discount app every second
// --------------------------------------------------------


// regular translations (repeatable)
const translations = [
                        {
                        element: 'div.docapp-cart-item:nth-child(1) > span:nth-child(1)',
                        german: 'Zwischensumme'
                        }, 
                        {
                        element: '.add-disc .add-desc-inner',
                        german: 'Rabattcode hinzufügen'
                        }, 
                        {
                        element: '.docapp-coupon-input .docapp-coupon-input--input-container .docapp-coupon-input--button .docapp-coupon-input--button-text',
                        german: 'hinzufügen'
                        }, 
                        {
                        element: 'div.docapp-cart-item:nth-child(2) > span:nth-child(1)',
                        german: 'Rabattcode'
                        }             
                     ]


const translate = (object) => {
    const target = document.querySelector(object.element)
    const translation = object.german
  
  if (target && !target.classList.contains("translated")) {
        target.textContent = translation
        target.classList.add("translated")
  }
}


$(document).ready(function(){
  setInterval(function() {
    translations.forEach(object => translate(object))
  }, 1000)
})


// discount code - placeholder  
const translatePlaceholder = () => {  

  const target = document.querySelector('.drawer-footer .docapp-cart-with-coupon-summary input[type="text"]')
  
  if (target && !target.classList.contains("translated")) {
    $('.drawer-footer .docapp-cart-with-coupon-summary input[type="text"]').attr('placeholder','Rabattcode');
    target.classList.add("translated")
  }  
}

// until free shipping with money span inside
const translateWithPrice = () => {  
  
  const target = document.querySelector('.drawer-footer .docapp-cart-with-coupon-summary .docapp-free-shipping-promo')
  const price = document.querySelector('.drawer-footer .docapp-cart-with-coupon-summary .docapp-free-shipping-promo span')
  const translation1 = 'Vom KOSTENLOSEN VERSAND sind Sie noch '
  const translation2 = ' entfernt!'
    
  if (target && !target.classList.contains("translated")) {
    target.innerHTML = translation1 + price.textContent + translation2
    target.classList.add("translated")
  }
}
setInterval(function() {
  translateWithPrice()
  translatePlaceholder()
}, 1000)

